import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { stylingHelpers } from '../designTokens';
import { Image, Spacing, TextBlock } from '../components';
import TeamLogos from './TeamLogos';

const { flexStack } = stylingHelpers;

const Container = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.spacings.kilo};
  ${flexStack()}
`;

const ImageList = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: ${({ theme }) => theme.spacings.mega} 0;
`;

const ImageItem = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 0 ${({ theme }) => theme.spacings.mega};

  img {
    width: auto;
    max-height: 35px;
  }
`;

const TextWrapper = styled.div`
  padding: ${({ theme }) => theme.spacings.kilo} 0;
  width: 100%;
`;

const ClickHandler = styled.div`
  pointer-events: none;
  span {
    text-decoration: underline;
    cursor: pointer;
    pointer-events: auto;
  }
`;

const customStylesFooter = (theme) => `
  a {
    color: ${theme.colors.r500};
    text-decoration: underline;
  }
`;

const Footer = ({ cdnUrl, sponsorLogos, content, link, onLinkSelect }) => {
  const showSponsorLogos = sponsorLogos && !!sponsorLogos.length;

  return (
    <Container>
      {showSponsorLogos && (
        <ImageList>
          {sponsorLogos.map(({ id, src, alt }) => (
            <ImageItem key={id}>
              <Image src={`${cdnUrl}${src}`} alt={alt} />
            </ImageItem>
          ))}
        </ImageList>
      )}
      {content && (
        <TextWrapper>
          <Spacing bottom>
            <TeamLogos cdnUrl={cdnUrl} />
          </Spacing>
          <TextBlock styles={customStylesFooter} text={content} size='kilo' light />
          {link && (
            <ClickHandler onClick={onLinkSelect}>
              <TextBlock text={link} size='kilo' light />
            </ClickHandler>
          )}
        </TextWrapper>
      )}
    </Container>
  );
};

Footer.propTypes = {
  sponsorLogos: PropTypes.array,
  content: PropTypes.string,
  link: PropTypes.string,
  onLinkSelect: PropTypes.func,
};

Footer.defaultProps = {
  sponsorLogos: [
    {
      id: 'nhl-logo',
      src: 'NHL.png',
      alt: 'NHL Logo',
    },
    {
      id: 'tims-logo',
      src: 'TimLogo2024.svg',
      alt: 'Tim Hortons Logo',
    },
    {
      id: 'nhlpa-logo',
      src: 'NHLPA.png',
      alt: 'NHLPA Logo',
    },
  ],
  content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Mauris malesuada porta dapibus. Ut ac risus dui. Donec id
            tellus sit amet felis vestibulum pulvinar. Sed suscipit,
            augue a mattis maximus, enim magna tempus nulla, ac sagittis
            magna mauris sed felis. Suspendisse potenti. Fusce tincidunt
            velit eleifend tincidunt faucibus. Etiam non placerat arcu.`,
  onLinkSelect: () => console.log('Clicked!'),
};

export default Footer;
